var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSocialPinterest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 50a25 25 0 010-50 25 25 0 010 50zm.8-38.6c-7.6 0-11.4 5.4-11.4 10 0 2.7 1 5.2 3.2 6 .4.2.7 0 .8-.3l.4-1.2c0-.4 0-.5-.3-1-.6-.6-1-1.6-1-3 0-4 3-7.7 8-7.7 4.2 0 6.5 2.7 6.5 6.2 0 4.7-2 8.6-5 8.6-1.7 0-3-1.4-2.6-3 .5-2.2 1.4-4.3 1.4-5.8 0-1.3-.7-2.4-2-2.4-1.8 0-3.2 1.8-3.2 4 0 1.6.5 2.7.5 2.7L19 33c-.6 2.6 0 5.7 0 6s.3.3.4.2c0-.2 2.2-2.8 3-5.3 0-.8 1-4.5 1-4.5.5 1 2.2 2 4 2 5 0 8.5-4.7 8.5-11 0-4.7-4-9-10.2-9z",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-social--pinterest-5a706b665cf9755df3a53ac22e8d41e1.svg";
export { SvgIconSocialPinterest as Component };